module.exports = __webpack_public_path__ + "static/stratosbanner-5f8c799e8875020c26c3e1095dc04ddf.png";